import type { SpirometerSoftwareNames } from '../../../../../../common/enums/spirometerSoftwareNames';
import { applyServiceConsumerFilters } from '../../../../../store/serviceConsumers/serviceConsumerActions';
import { useSelectRedux } from '../../../../../utils/hooks/useSelectRedux';

export function useLoadServiceConsumer(
    serviceId: string,
    additionalIds: { employmentId: string }
): IServiceConsumer | undefined;
export function useLoadServiceConsumer(
    serviceId: string,
    additionalIds: { organizationId: string; practitionerId: string }
): IServiceConsumer | undefined;
export function useLoadServiceConsumer(
    serviceId: string,
    additionalIds: { employmentId?: string; organizationId?: string; practitionerId?: string }
): IServiceConsumer | undefined {
    const serviceConsumers = useSelectRedux((state) => state.serviceConsumers.data.serviceConsumers);

    const serviceConsumer = applyServiceConsumerFilters({ serviceId, ...additionalIds }, serviceConsumers)[0];

    if (serviceConsumer) {
        return {
            id: serviceConsumer.id,
            usingSpirometer: serviceConsumer.usingSpirometer,
            spirometerSoftwareName: serviceConsumer.spirometerSoftwareName,
            usingRestEcgMeter: serviceConsumer.usingRestEcgMeter,
            followUpMeasurementGgz: serviceConsumer.followUpMeasurementGgz,
            weeksForFollowUpMeasurementGgz: serviceConsumer.weeksForFollowUpMeasurementGgz,
        };
    }
}

export type ServiceConsumerProp = { serviceConsumer?: IServiceConsumer };

export interface IServiceConsumer {
    followUpMeasurementGgz: boolean;
    id: string;
    spirometerSoftwareName: SpirometerSoftwareNames | null;
    usingRestEcgMeter: boolean;
    usingSpirometer: boolean;
    weeksForFollowUpMeasurementGgz: number | null;
}
